import React, { useState } from "react";
import PropTypes from "prop-types";
import ShopNavigationMobileItem from "./ShopNavigationMobileItem";
import "./ShopNavigationMobile.scss";

const ShopNavigationMobile = ({ title, items }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div
      className="ShopNavigationMobile"
      data-palette="blueberry"
      data-cutout="bottom"
      data-cutout-style="wave"
    >
      <div className="SectionHeading">
        <div className="container-guttered">
          <h1 className="SectionHeading__heading SectionHeading__heading--left">
            {title}
          </h1>
        </div>
      </div>
      <ul className="ShopNavigationMobile__primary-list">
        {items?.map((item, index) => {
          const isActive = activeIndex === index;

          return (
            <ShopNavigationMobileItem
              {...item}
              key={item.title}
              active={isActive}
              handleClick={() => setActiveIndex(isActive ? null : index)}
              columns={item.document.body.map(({ id, items }) => ({
                id,
                items,
              }))}
            />
          );
        })}
      </ul>
    </div>
  );
};

ShopNavigationMobile.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
      }),
      document: ShopNavigationMobileItem.propTypes.columns,
    })
  ),
};

export default ShopNavigationMobile;
